import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('reinsurance-input');

export const ADD_REINSURER_REFERAL_RECORD = getActionName('ADD_REINSURER_REFERAL_RECORD');
export const UPDATE_REINSURER_REFERAL_RECORD = getActionName('UPDATE_REINSURER_REFERAL_RECORD');
